import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { of, switchMap } from 'rxjs';
import { Community } from '@models/communities/community.model';
import { IMigFormService } from '../services/mig-form.service';
import { catchError } from 'rxjs/operators';
import { notfound } from '@functions/routing';

@Injectable({
  providedIn: 'root',
})
export class MigCommunitiesGuard implements CanActivate {
  module = inject(IMigFormService);
  router = inject(Router);
  route = inject(ActivatedRoute);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const corporation = this.module.corporation$.value;
    if (corporation) {
      return this.module.api
        .get<Community[]>(`corporations/${corporation.id}/communities`)
        .pipe(
          switchMap(response => {
            if (response) {
              this.module.communities$.next(response);
              return of(true);
            }
            this.router.navigate(['/']).then();
            return of(false);
          }),
          catchError(error => {
            this.router.navigate(['/']).then();
            return of(false);
          })
        );
    }
    return notfound(this.router);
  }
}
